import store from '@/store'

export default [
  {
    path: '/exchange-transactions',
    name: 'exchange-transaction',
    meta: { requiresAuth: true },
    component: () => import('@/pages/exchange-transaction/index.vue')
  },
  {
    path: '/exchange-transactions/:id',
    name: 'exchange-transaction-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/exchange-transaction/index.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('exchangeTransaction/find', to.params.id)
      next()
    }
  }
]
